/* Button-specific resets not provided by .promo-card global */
:global(.promo-card .title) > button {
    background: none;
    border: none;
    text-align: left;
    color: inherit;
    cursor: inherit;
    font: inherit;
}

.chipRow {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-2x);
    margin: var(--bi-scale-4x) 0;

    .chipHeading {
        font: var(--bi-font-label-large);

        @media (width < 768px) {
            font: var(--bi-font-label-medium);
        }
    }

    .chips {
        display: flex;
        flex-wrap: wrap;
        gap: var(--bi-scale-1x);

        > .chip {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
            max-width: 100%;
        }
    }
}
